import React from 'react';
import Icon from '../../../components/AppIcon';

const statConfigs = [
  {
    key: 'activeProjects',
    title: 'Active Stacks',
    icon: 'FolderOpen',
    gradient: 'linear-gradient(135deg, #F58A54, #F06F6B)',
    clickable: true,
  },
  {
    key: 'pendingQuotes',
    title: 'Pending Quotes',
    icon: 'Clock',
    gradient: 'linear-gradient(135deg, #F06F6B, #E0528A)',
    clickable: false,
  },
  {
    key: 'completedProjects',
    title: 'Completed',
    icon: 'CheckCircle',
    gradient: 'linear-gradient(135deg, #10B981, #059669)',
    clickable: false,
  },
  {
    key: 'upcomingDeadlines',
    title: 'Drafts',
    icon: 'FileText',
    gradient: 'linear-gradient(135deg, #E0528A, #F58A54)',
    clickable: false,
  },
];

const ProjectStats = ({ stats, onActiveProjectsClick }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statConfigs?.map((config) => (
        <div
          key={config?.key}
          className={`bg-card border border-border rounded-2xl p-5 transition-all duration-200 ${
            config?.clickable
              ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5 hover:border-primary/30'
              : ''
          }`}
          onClick={config?.clickable ? onActiveProjectsClick : undefined}
        >
          <div className="flex items-start justify-between mb-3">
            <div
              className="w-11 h-11 rounded-2xl flex items-center justify-center shadow-sm"
              style={{ background: config?.gradient }}
            >
              <Icon name={config?.icon} size={20} color="white" />
            </div>
            {config?.clickable && (
              <div className="w-6 h-6 rounded-lg bg-muted flex items-center justify-center">
                <Icon name="ArrowRight" size={12} color="#9CA3AF" />
              </div>
            )}
          </div>
          <div className="text-2xl font-bold text-foreground mb-0.5">
            {stats?.[config?.key] ?? 0}
          </div>
          <div className="text-xs text-text-secondary font-medium">{config?.title}</div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;